<template>
  <div>
    <!-- <TitleLogo title="공주의 앨범 상세보기" />
    <v-divider></v-divider> -->
    <v-sheet v-if="isLoading" class="text-center mt-10">
      <div class="font-weight-medium text-body-1 pb-4">Loading...</div>
      <v-progress-circular size="48" :width="2" color="primary" indeterminate></v-progress-circular>
    </v-sheet>

    <v-sheet v-else class="pb-4 mx-auto">
      <v-img class="sela-dialog-card-content" :src="item.imageUrl" :lazy-src="item.thumbnailUrl" :key="item.imageUrl" contain>
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular color="white" indeterminate></v-progress-circular>
          </div>
        </template>
      </v-img>

      <div class="px-4 py-2">
        <div v-if="showEditNudge" class="edit-nudge" role="note">
          <p class="edit-nudge__title"><span aria-hidden="true">✦</span> {{ $t("page.pictureDetail.edit-nudge-title") }}</p>
          <p class="edit-nudge__body">{{ $t("page.pictureDetail.edit-nudge-body") }}</p>
          <div class="edit-nudge__actions">
            <button type="button" class="edit-nudge__primary" @click="startEdit()">{{ $t("page.pictureDetail.edit-nudge-edit") }}</button>
            <button type="button" class="edit-nudge__secondary" @click="dismissEditNudge()">{{ $t("page.pictureDetail.edit-nudge-keep") }}</button>
          </div>
        </div>
        <!-- 겁주는 확인창('영구히 사라집니다') 없이 바로 편집 화면. 편집 화면에서 그만두면 원래 사진 그대로다 -->
        <PanelButton :class="{ 'edit-nudge-pulse': showEditNudge }" @click="startEdit()" :disabled="!isEditable(item)" :title="$t('dialog.edit-composite')" :message="$t('dialog.edit-guide')" />

        <div style="height: 6px"></div>

        <PanelButton @click="goToPrintReq" :title="$t('page.pictureDetail.print-title')" :message="$t('page.pictureDetail.print-subtitle')" />

        <div class="d-flex justify-center align-center py-2" style="gap: 8px">
          <v-btn outlined class="sela deactivate text-body-1" @click="shareImage()" style="flex-grow: 1"> {{ $t("button.friend-share") }} </v-btn>
          <v-btn outlined class="sela deactivate text-body-1" @click="writeReview()" width="32%"> {{ hasReview ? $t("button.review-edit") : $t("button.review-write") }} </v-btn>
          <v-btn outlined class="sela text-body-1" @click="openUrlForDownload()" width="25%"> {{ $t("button.savein-myphone") }}</v-btn>
        </div>
      </div>

      <ReviewWriteDialog v-if="reviewDialog" :visible="reviewDialog" :item="item" @close="reviewDialog = false" :key="item.id" />
    </v-sheet>
  </div>
</template>
<script>
import TitleLogo from "@/views/components/TitleLogo"
import DialogHeader from "@/views/components/DialogHeader"
import ReviewWriteDialog from "./components/ReviewWriteDialog"
import { fetchMyPictureItem } from "@/models/MyPicture"
import PanelButton from "@/views/components/PanelButton"

export default {
  components: {
    TitleLogo,
    DialogHeader,
    ReviewWriteDialog,
    PanelButton,
  },

  data: () => ({
    item: null,
    isLoading: true,
    reviewDialog: false,
    hasReview: false,
    showEditNudge: false,
  }),

  created() {},

  mounted() {
    fetchMyPictureItem(this, this.$route.params.id)
      .then((item) => {
        this.item = item
        console.log("MyPictureDialog mounted", this.item)
        this.showEditNudge = Boolean(item) && this.isEditable(item) && !this.isEditNudgeDone(item.id)

        if (this.item) {
          this.$http
            .post("/api/review/select/request", {
              params: {
                requestId: this.item.id,
              },
            })
            .then((res) => {
              if (res.data.length > 0) {
                this.hasReview = true
              } else {
                this.hasReview = false
              }
            })
        }
      })
      .catch((e) => {
        console.log(e)
        alert(this.$t("alert.error_failed_get_information"))
        this.$router.back()
      })
      .finally(() => {
        this.isLoading = false
      })
  },

  methods: {
    async shareImage() {
      await this.$shareLink(this.item.imageUrl)
    },

    writeReview() {
      this.reviewDialog = true
    },

    downloadImage() {
      const a = document.createElement("a")
      a.href = this.item.imageUrl
      a.download = this.item.filename
      a.click()
    },
    openUrlForDownload() {
      window.open("https://front.sela-castle.com/imageViewer-v1.html?image=" + this.item.filename, "_blank")
    },
    editPicture() {
      this.$router.push(`/mypage/picEdit/${this.item.id}`)
    },

    // 수정 안내는 사진마다 한 번: 수정을 누르거나 '이대로 좋아요'를 누르면 이 기기에서 다시 띄우지 않는다
    editNudgeKey(id) {
      return `sela_edit_nudge_done_${id}`
    },

    isEditNudgeDone(id) {
      try {
        return window.localStorage.getItem(this.editNudgeKey(id)) === "1"
      } catch (e) {
        return false
      }
    },

    markEditNudgeDone() {
      this.showEditNudge = false
      try {
        window.localStorage.setItem(this.editNudgeKey(this.item.id), "1")
      } catch (e) {
        // 저장할 수 없는 브라우저면 다음에 다시 안내한다
      }
    },

    startEdit() {
      if (!this.isEditable(this.item)) return
      this.markEditNudgeDone()
      this.editPicture()
    },

    dismissEditNudge() {
      this.markEditNudgeDone()
    },

    isEditable(item) {
      if (!item.editable || !item.completeDate) {
        return false
      }
      const isBaseEditableDate = "24.5.1"
      const isBaseEditableDay = this.dayjs(isBaseEditableDate, "YY.M.D", true)
      const completeDay = this.dayjs(item.completeDate, "YY.M.D", true)

      if (completeDay.isBefore(isBaseEditableDay)) {
        return false
      } else {
        return true
      }
    },

    goToPrintReq() {
      this.$router.push({ name: "printPicPay", params: { id: this.$route.params.id, pic: this.item } })
    },
  },
}
</script>
<style scoped>
/* 처음 보는 완성 사진: 인물 위치는 손님이 직접 맞추는 단계라는 안내(배치를 잘못된 사진으로 오해하는 문의 방지) */
.edit-nudge {
  position: relative;
  margin: 4px 0 12px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 214, 228, 0.7);
  border-radius: 16px;
  color: #fffafb;
  background: linear-gradient(135deg, #b92f5d 0%, #c83b68 54%, #b72d5a 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 10px 26px rgba(159, 35, 77, 0.32);
  animation: edit-nudge-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}

/* 말풍선 꼬리: 바로 아래 '인물 재배치' 단추를 가리킨다 */
.edit-nudge::after {
  content: "";
  position: absolute;
  bottom: -7px;
  left: 50%;
  width: 14px;
  height: 14px;
  background: #bd3260;
  border-right: 1px solid rgba(255, 214, 228, 0.7);
  border-bottom: 1px solid rgba(255, 214, 228, 0.7);
  transform: translateX(-50%) rotate(45deg);
}

.edit-nudge__title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.35;
  word-break: keep-all;
}

.edit-nudge__body {
  margin: 0 0 12px;
  color: rgba(255, 250, 251, 0.92);
  font-size: 13px;
  line-height: 1.5;
  word-break: keep-all;
}

.edit-nudge__actions {
  display: flex;
  gap: 8px;
}

.edit-nudge__primary,
.edit-nudge__secondary {
  min-height: 44px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
}

.edit-nudge__primary {
  flex: 1 1 auto;
  color: #b72d5a;
  background: #fffafb;
}

.edit-nudge__secondary {
  flex: 0 0 auto;
  color: #fffafb;
  border: 1px solid rgba(255, 250, 251, 0.6);
  background: transparent;
}

.edit-nudge__primary:focus-visible,
.edit-nudge__secondary:focus-visible {
  outline: 2px solid #ffd1dc;
  outline-offset: 2px;
}

.edit-nudge-pulse {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  animation: edit-nudge-pulse 1.4s ease-in-out infinite;
}

/* 단추 위로 흐르는 빛줄기: 눈길이 이 단추로 가게 한다 */
.edit-nudge-pulse::after {
  content: "";
  position: absolute;
  top: -20%;
  bottom: -20%;
  left: -40%;
  width: 35%;
  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.85), transparent);
  transform: skewX(-18deg);
  animation: edit-nudge-shine 2.2s ease-in-out infinite;
  pointer-events: none;
}

@keyframes edit-nudge-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes edit-nudge-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(216, 74, 120, 0.9), 0 0 0 0 rgba(216, 74, 120, 0.35);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(216, 74, 120, 0.35), 0 0 22px 10px rgba(216, 74, 120, 0.35);
    transform: scale(1.025);
  }
}

@keyframes edit-nudge-shine {
  0%,
  35% {
    left: -40%;
  }
  75%,
  100% {
    left: 120%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .edit-nudge,
  .edit-nudge-pulse {
    animation: none;
  }
  .edit-nudge-pulse {
    box-shadow: 0 0 0 4px rgba(216, 74, 120, 0.85);
  }
  .edit-nudge-pulse::after {
    animation: none;
    display: none;
  }
}
</style>
